<template>
    <v-footer app absolute padless>
        <v-card
            width="100%"
            height="100%"
            flat
            tile
            class="black white--text text-center"
        >
            <v-card-text
                class="footer-subtitle white--text d-flex align-center justify-center"
            >
                © NEXON America Inc. All Rights Reserved.
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<script>
export default {
    name: 'page-footer',
    data: function() {
        return {
            signupLink:
                'https://docs.google.com/forms/d/e/1FAIpQLSdIQUWEzAhxThFLt_duuyuCtbLuXGsAvovocGilAdxvJ6UbfA/viewform',
        };
    },
};
</script>
<style lang="scss" scoped>
.footer-title {
    position: relative;
    overflow: hidden;
    height: 228px;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    background-image: url('../assets/icons/front-page-box-divider.png'),
        url('../assets/footer_bg.jpg');
    background-position: bottom, center;
    background-size: 100% 4%, cover;

    .footer-shape-image {
        position: absolute;
        width: 280px;
        height: 136.3px;
        top: 0;
        left: 55%;
    }
    .footer-combine-image {
        position: absolute;
        width: 100px;
        height: 100px;
        top: 148px;
        left: 34%;
    }
}
.footer-subtitle {
    height: 72px;
    font-size: 13px;
    font-weight: 300;
    opacity: 0.6;
}
.btn-mail {
    margin-top: 30px;
    color: #2969e8;
    font-size: 14px;
    font-weight: 900;
    &:hover {
        box-shadow: 0 5px 10px 0 #2969e8;
    }
    &:focus {
        background-color: #efefef;
        box-shadow: none;
        opacity: 0.8;
    }
}
.v-btn {
    letter-spacing: normal;
    &:hover {
        &:before {
            color: transparent;
        }
    }
    &:focus {
        &:before {
            color: transparent;
        }
    }
    &:before {
        transition: none;
    }
}
.v-btn--rounded {
    border-radius: 30px;
}
.v-btn__content .v-icon--left {
    margin-right: 16px;
}

.theme--light.v-divider {
    border-color: grey;
}
</style>

<style lang="scss">
#btn_icon_normal {
    fill: #2969e8 !important;
}
</style>
